import { formatAssignedTaskDueLabel } from "@/lib/assignedTaskDue";

/** Exportación CSV de tareas asignadas (Actividades de Equipo). */

/**
 * @param {object[]} tasks
 * @param {Map<string, object>} usersById
 * @returns {string}
 */
export function buildAssignedTasksCsvRows(tasks = [], usersById = new Map()) {
  const esc = (value) => {
    const s = String(value ?? "").replace(/"/g, '""');
    return `"${s}"`;
  };
  const lines = [
    [
      "Auxiliar",
      "Tarea",
      "Prioridad",
      "Fecha límite",
      "Creada",
      "Leída auxiliar",
      "Realizada auxiliar",
      "Cerrada administrador",
      "Estado",
    ].join(","),
  ];
  for (const task of tasks) {
    const user = usersById.get(task.assigned_to_user_id);
    const name = user?.name || user?.email || task.assigned_to_user_id || "";
    const status = task.admin_closed_at
      ? "Concluida"
      : task.aux_completed_at
        ? "Por validar admin"
        : task.aux_read_at
          ? "Leída"
          : "Abierta";
    lines.push(
      [
        esc(name),
        esc(task.body),
        esc(task.priority || "media"),
        esc(formatAssignedTaskDueLabel(task.due_date)),
        esc(task.created_at ? String(task.created_at).slice(0, 19) : ""),
        esc(task.aux_read_at ? String(task.aux_read_at).slice(0, 19) : ""),
        esc(task.aux_completed_at ? String(task.aux_completed_at).slice(0, 19) : ""),
        esc(task.admin_closed_at ? String(task.admin_closed_at).slice(0, 19) : ""),
        esc(status),
      ].join(","),
    );
  }
  return lines.join("\n");
}

/** @param {string} csv @param {string} filename */
export function downloadAssignedTasksCsv(csv, filename = "tareas-equipo.csv") {
  const blob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/** @param {object[]} tasks @param {string} [monthPrefix] YYYY-MM */
export function filterTasksByClosedMonth(tasks = [], monthPrefix = "") {
  const prefix = String(monthPrefix || "").slice(0, 7);
  if (!prefix) return tasks;
  return tasks.filter((task) => String(task.admin_closed_at || "").slice(0, 7) === prefix);
}
